import { Text } from '@radix-ui/themes'
import cn from 'classnames'

export const FieldLabel = ({ children, hidden = false }: { children: string; hidden?: boolean }) => (
  <Text as="label" size="1" color="gray" className={cn('block mb-1', hidden && 'sr-only')}>
    {children}
  </Text>
)
